import { cn, forwardRef, Image } from "@heroui/react";
import { motion } from "framer-motion";
import { ElementType, ReactElement, useMemo } from "react";

export const MultiAvartar = forwardRef<'div', any>(({ list, classNames = {}, as, ...props }: {
  list: any[],
  as?: ElementType
  classNames?: {
    base?: string
    avatarWrapper?: string,
    count?: string
  },
}, ref) => {


  const avatars = useMemo(() => {
    return list.slice(1, 3)
  }, [list])

  const Component = as || 'div'

  return <Component data-multi={list.length >= 3}
    {...props}
    ref={ref}
    className={
      cn(
        "text-[12px] rounded-[10px] data-[multi=false]:justify-center p-[4px] gap-1 flex flex-col justify-end items-center w-[40px] h-[40px] bg-theme-primary/5",
        "group/item transition-background  group-data-[selected=true]:bg-transparent",
        classNames.base
      )

    }
  >
    <div className={cn(
      "h-[40%] group-data-[multi=false]/item:h-[55%] overflow-hidden justify-center flex",
      classNames.avatarWrapper
    )}>
      <Image classNames={{
        wrapper: `h-full aspect-square `,
        img: "object-cover h-full aspect-square"
      }}
        radius="full"
        src={list[0]}
      />
      {avatars.map((item, i) =>
        <Image key={i} classNames={{
          wrapper: `h-full aspect-square ml-[-10%]`,
          img: "object-cover h-full aspect-square"
        }}
          alt={item}
          radius="full"
          src={item}
        />)}
    </div>

    <motion.span
      className={cn(
        "text-theme-primary/70 leading-[1] group-data-[multi=false]/item:hidden",
        classNames.count

      )}
    >{list.length}</motion.span>
  </Component>
})